import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './plugins/element-ui'
import './assets/style/global.css'
// 引入 Noto Sans SC 字体
import 'notosans-fontface/css/notosans-fontface-modern.css';

// 添加全局字体样式
const style = document.createElement('style');
style.textContent = `
  * {
    font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-size: 14px;
  }
  
  html, body, #app {
    font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-size: 14px;
  }
  
  .el-table {
    font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-size: 14px !important;
  }
  
  .el-table th,
  .el-table td {
    font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-size: 14px !important;
  }
  
  .el-button {
    font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-size: 14px !important;
  }
  
  .el-input__inner,
  .el-select,
  .el-pagination {
    font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-size: 14px !important;
  }
`;
document.head.appendChild(style);

// 引入全屏插件
import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen)

// 引入rem.js
import '/utils/rem.js';




Vue.config.productionTip = false
Vue.prototype.$baseUrl = 'https://home.techresource.cn'
// Vue.prototype.$baseUrl = 'http://learn.com'

console.log(process.env.VUE_APP_HOST)
console.log(process.env.VUE_APP_NAME)
console.log(process.env.VUE_APP_MACHINEID)



new Vue({
  el: '#app',
  router,
  store,
  render: function (h) { return h(App) },
  mounted() {
    // 阻止右键菜单
    document.addEventListener('contextmenu', event => event.preventDefault());
    // 阻止F12开发者工具
    // document.addEventListener('keydown', event => {
    //   if (event.key === 'F12') {
    //     event.preventDefault();
    //   }
    // });
  }
}).$mount('#app')
